import React from 'react';
import {Route, Switch} from 'react-router-dom';

// Leave this commented out for now since we don't want the Feed to import these huge apps
// until we get them code split properly.
import SearchPageWithStore from './SearchPageWithStore';
import BrowsePageWithStore from './BrowsePageWithStore';
import FeedPageWithStore from './FeedPageWithStore';

// const SearchPageRoutesWithQuery = (props) => (
//     <Switch>
//         <Route path={`${props.match.path}/`} render={(routerProps) => <SearchPageWithStore {...props} {...routerProps} />} />
//         <Route path={`${props.match.path}/:query`} render={(routerProps) => <SearchPageWithStore {...props} {...routerProps} />} />
//     </Switch>
// );

const SearchPageRoutes = (props) => (
    <Switch>
        <Route path={`${props.match.path}/events/`} render={(routerProps) => <BrowsePageWithStore {...props} {...routerProps} />} />
        <Route path={`${props.match.path}/:query`} render={(routerProps) => <SearchPageWithStore {...props} {...routerProps} />} />
        {/* <Route path={`${props.match.path}/free--events`} render={(routerProps) => <SearchPageRoutesWithQuery {...props} {...routerProps} isFree={true} />} />
        <Route path={`${props.match.path}/(free--)?:category--events--:time`} render={(routerProps) => <SearchPageRoutesWithQuery {...props} {...routerProps} isFree={!!routerProps.match.params[0]} />} />
        <Route path={`${props.match.path}/(free--)?events--:time`} render={(routerProps) => <SearchPageRoutesWithQuery {...props} {...routerProps} isFree={!!routerProps.match.params[0]} />} />
        <Route path={`${props.match.path}/(free--)?:category--events`} render={(routerProps) => <SearchPageRoutesWithQuery {...props} {...routerProps} isFree={!!routerProps.match.params[0]} />} />
        <Route path={`${props.match.path}/:query`} render={(routerProps) => <SearchPageWithStore {...props} {...routerProps} />} /> */}
    </Switch>
);

export default function PageRoutes(props) {
    return (
        <Switch>
            {/* /esi_cache is the request path when Varnish renders the page */}
            <Route path="/esi_cache" exact={true} render={(routerProps) => <FeedPageWithStore {...props} {...routerProps} />} />
            <Route path="/" exact={true} render={(routerProps) => <FeedPageWithStore {...props} {...routerProps} />} />
            <Route path="/d/:locationSlug" render={(routerProps) => <SearchPageRoutes {...props} {...routerProps} />} />
        </Switch>
    );
}
